import styled from "styled-components";

export const Container = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  div:nth-child(2) {
    margin: 40px 0 24px 0;
  }
`;

export const Link = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.blue.link};
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    opacity: 0.5;
  }
`;

export const DisabledInput = styled.input`
  display: none;
`;
